import React from "react";
import { ESTADOS, getDesviacion, getEstado, hhmm } from "../SalidasStatus/statusHelper";
import { ESTADOS_SALIDA } from "./operadorHelper";

const SalidaTile = ({ salida, selected, onClick }) => {
  const ciclo = ESTADOS_SALIDA[salida.estado] ?? ESTADOS_SALIDA.programada;
  const { desv, tolerancia } = getDesviacion(salida);
  const puntualidad = ESTADOS[getEstado(desv, tolerancia)];

  const sub = salida.regreso
    ? `Reg ${hhmm(salida.regreso)}`
    : salida.estado === "en_curso"
      ? "En ruta"
      : "Reg —";

  return (
    <button
      type="button"
      className={`operador-tile${selected ? " is-selected" : ""}`}
      onClick={onClick}
    >
      <div className="operador-tile-hora">
        <div style={{ fontSize: "17px", fontWeight: 700 }}>{salida.hora}</div>
        <div style={{ fontSize: "10.5px", fontWeight: 600, color: "#777a89" }}>{sub}</div>
      </div>

      <div style={{ minWidth: 0, flex: 1 }}>
        <div className="text-truncate" style={{ fontSize: "14.5px", fontWeight: 600 }}>
          {salida.ramal_nombre}
        </div>
        <div style={{ fontSize: "12.5px", fontWeight: 500, color: "#777a89" }}>
          #{salida.id} · Unidad {salida.unidad ?? "-"}
        </div>
      </div>

      <span
        className="operador-pill"
        style={{ background: ciclo.bg, border: `1px solid ${ciclo.bd}`, color: ciclo.ink, flex: "none" }}
      >
        {ciclo.label}
      </span>
      <span
        title={puntualidad.label}
        style={{ width: 9, height: 9, borderRadius: "50%", background: puntualidad.color, flex: "none" }}
      />
      <i className="mdi mdi-chevron-right" style={{ fontSize: "18px", color: "#777a89" }}></i>
    </button>
  );
};

export default SalidaTile;
